import { useMutation, useQueryClient } from 'react-query';
import * as api from '../../services/api';
import { HELP_DESK_TICKETS_QUERY_KEY } from './useHelpDeskTickets';

const useHelpDeskCreateTicket = ({ accountId }) => {
  const queryClient = useQueryClient();

  const { mutateAsync: createTicketAsync, isLoading } = useMutation(
    (body) => api.createHelpDeskTicket({ accountId, ...body }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: (query) => Array.isArray(query.queryKey) && query.queryKey[0] === HELP_DESK_TICKETS_QUERY_KEY
        });
      }
    }
  );

  return { createTicketAsync, isLoading };
};

export default useHelpDeskCreateTicket;
